import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './hooks/useAuth';
import { HelmetProvider } from 'react-helmet-async';

// Import Swiper styles globally
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

// Add a small delay before rendering to ensure all libraries are loaded
setTimeout(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  // Remove strict mode to avoid double rendering that can cause issues with external libraries
  root.render(
    <HelmetProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </HelmetProvider>
  );

  // Register the reportWebVitals function
  reportWebVitals();
}, 100);
